import type { AxiosError } from 'axios';

interface ErrorBody {
  readonly error?: unknown;
  readonly details?: unknown;
}

const responseOf = (err: unknown) => (err as AxiosError<ErrorBody> | undefined)?.response;

const THUMBNAIL_IN_PROGRESS = 'AppThumbnailInProgress';

/** A thumbnail is already being drawn for the app; the draft itself is fine. */
export const isThumbnailInProgress = (err: unknown): boolean => responseOf(err)?.data?.error === THUMBNAIL_IN_PROGRESS;

/** The draft moved on since it was loaded: someone (usually the assistant) saved first. */
export const isDraftConflict = (err: unknown): boolean =>
  responseOf(err)?.status === 409 && !isThumbnailInProgress(err);

/** Every reason the server refused the draft, or none when it was refused for something else. */
export const manifestProblemsOf = (err: unknown): string[] => {
  const body = responseOf(err)?.data;
  if (body?.error !== 'AppInvalidManifest' || !Array.isArray(body.details)) return [];
  return body.details.filter((problem): problem is string => typeof problem === 'string');
};
